import React from 'react';
import Header from '../../../../components/layout/headers/Header'
import Sidebar from '../../../../components/layout/navigation/sidebar/DynamicSidebar';
import CustomersProfileReportTable from './CustomersProfileReportTable'

const CustomersProfileReport = () => {
    return (
        <>
            <Header/>
            <Sidebar/>
            <div className="content-body">
                <div className="w-full px-4">
                    <CustomersProfileReportTable/>
                </div>
            </div>
        </>
    );
}

export default CustomersProfileReport;